import { FC } from "react";
import cn from "classnames";
import { Tab, TabGroup, TabList } from "@headlessui/react";
import { useTabContext } from "@/components/TabPanels/TabContext";

type CategoryTabNavigationProps = {
  tabClickOverride?: boolean;
};

export const CategoryTabNavigation: FC<CategoryTabNavigationProps> = ({
  tabClickOverride = false,
}) => {
  const { tabs, activeTab, setActiveTab } = useTabContext();

  if (!tabs?.length) return null;

  return (
    <TabGroup
      manual
      selectedIndex={activeTab}
      onChange={setActiveTab}
      as="div"
      className="block"
    >
      <TabList
        as="ul"
        className="flex flex-wrap items-stretch justify-center gap-4 md:flex-nowrap"
      >
        {tabs?.map((tab, index) => (
          <Tab
            data-linktype={tab.dlt}
            data-linkdetail={tab.dld}
            data-automation-group="category"
            data-automation-id={`category-${index}`}
            key={`${tab.label}-${index}`}
            onClick={() => tabClickOverride && setActiveTab(index)}
            className={cn(
              "group font-geist text-link-xs border-swdc-white/60 relative flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-xl border-t-2 border-r border-b border-l-2 bg-[linear-gradient(150deg,rgba(35,26,56,0.70)_0%,rgba(15,12,28,0.80)_73.21%)] px-6 py-4 text-center font-bold tracking-[0.125rem] backdrop-blur-sm outline-none after:absolute after:top-1/2 after:-right-8 after:h-6 after:-translate-y-1/2 data-focus:shadow-[inset_0_0_0_2.5px_white,inset_0_0_0_4.5px_var(--color-swdc-blue-325),inset_0_0_0_6.5px_white] sm:w-[calc(50%-0.5rem)] md:flex-1 lg:max-w-63",
              index === activeTab
                ? "text-swdc-white data-active:text-swdc-gray-200 cursor-default"
                : "text-swdc-gray-200 hover:text-swdc-white data-active:text-swdc-gray-200",
            )}
            as="li"
          >
            <div className="absolute -top-px h-0.5 w-52.5 bg-[linear-gradient(90deg,rgba(0,0,0,0)_0%,rgba(255,255,255,0.20)_50%,rgba(0,0,0,0)_100%)] shadow-[0_0_8px_0_rgba(255,255,255,0.30)]" />
            {tab.label}
            {index !== activeTab && (
              <div className="absolute right-0 bottom-0 left-0 h-0.5 origin-center rounded-b-xl bg-white opacity-0 shadow-[0_4px_4px_0_rgba(255,255,255,0)_inset,0_0_16px_0_rgba(255,255,255,0.75)] transition-opacity duration-200 group-hover:opacity-100" />
            )}
            {index === activeTab && (
              <div className="absolute right-0 bottom-0 left-0 h-1.25 origin-center scale-x-100 rounded-b-xl bg-white shadow-[0_4px_4px_0_rgba(255,255,255,0)_inset,0_0_16px_0_rgba(255,255,255,0.75)] transition-transform duration-700 ease-out group-data-focus:h-0.5 starting:scale-x-0" />
            )}
          </Tab>
        ))}
      </TabList>
    </TabGroup>
  );
};
